import { SitemapLevelFilter } from "./engine-mapbox-filter-types";

/**
 * Creates a filter expression to filter map objects by their level
 */
export const createMapboxLevelFilter = (currentLevel: number): SitemapLevelFilter => ["==", ["get", "level"], currentLevel];
